<template>
	<div class="content pa-content">
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>  
			</div>
		</transition>
		<div class="case-content">
			<div class="container">
				<div class="case-title wow animate__animated animate__fadeInUp animate__delay-0.3s">
					<b>{{ langs.case6 }}</b>
					<div class="curr-localtion fr">
						<el-breadcrumb separator-class="el-icon-arrow-right">
							<el-breadcrumb-item :to="{ path: '/' }">{{ langs.header1 }}</el-breadcrumb-item>
							<el-breadcrumb-item :to="{ path: '/cases' }">{{ langs.header5 }}</el-breadcrumb-item>
							<el-breadcrumb-item></el-breadcrumb-item>
						</el-breadcrumb>
					</div>
				</div>
				<div class="case-detail">
					<h2>{{ currCase.title }}</h2>
					<el-row>
						<el-col :xs="24" :md="12" class="case-detail-image">
							<img :src="currCase.imglist[0].url" alt="">
						</el-col>
						<el-col :xs="24" :md="12" class="case-detail-image">
							<img :src="currCase.imglist[1].url" alt="">
						</el-col>
					</el-row>
					<el-row>
						<el-col :xs="24" :md="12" class="case-detail-image">
							<img :src="currCase.imglist[2].url" alt="">
						</el-col>
						<el-col :xs="24" :md="12" class="case-detail-image">
							<img :src="currCase.imglist[3].url" alt="">
						</el-col>
					</el-row>
					<div class="case-detail-text">
						{{ currCase.text }}
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		data() {
			return {
				showLoading: true,
				caseId: 0, //
				currCase: [],
				
				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh, 
				caselist: [],
				caselist1: [
					{
						id:1,
						title: '西藏 - 拉萨 - 智能快递柜案例详情',
						text: '随着快递柜的快速发展，我们的生活不断便捷，智能储物柜的应用使物品便于存储，现代社会，网购已是人们重要的购物途径，而购物习惯的变化，已使中国的快递行业在过去的十年中迅速成长起来。但是目前智能快递柜在我国还处于发展的初级阶段。很多地方还不完善，常常使用过程中会出现一些问题和用户的投诉，在短期内很难大规模的使用和推广，所以我们仍需慢慢摸索。总而言之，目前我国智能快递柜的发展前景十分乐观，市场潜力巨大，但同时也面临着诸多发展难题。智能快递柜目前主要有三种运行模式：快递行业自建自用、电商自建自用、第三方平台公用。很多高科技公司也相继推出了各种智能快递柜，分布在高校、写字楼、工厂、园区、公司网点、物业、社区等地。为人们提供快速便利的快递取件服务。',
						imglist: [
							{'url':require('../../static/images/case/1-1.png')},
							{'url':require('../../static/images/case/1-2.png')},
							{'url':require('../../static/images/case/1-3.png')},
							{'url':require('../../static/images/case/1-4.png')},
						]
					},
					{
						id:2,
						title: '山东 - 青岛 - RFID智能柜案例详情',
						text: 'RFID智能手机柜是通过RFID物联网技术，RFID具有全球唯一ID编码，不可复制，确保其唯一性；对每个所需管理的工具镶嵌RFID电子标签进行身份识别，柜子内部为RFID监测系统，实时检测柜子内的物品信息。通过指纹、人脸识别来确定使用者信息，使用人员开门的瞬间，视觉系统会主动抓拍防止他人盗用人员信息，使用人员拿走任何物品，系统会自动进行识别，同时推送数据至后台生成报表。智能RFID手机寄存柜同时可在后台设置存取开锁时间段。RFID智能柜帮助企业灵活、安全、低成本的部署并管理物品，实现可视化管理。',
						imglist: [
							{'url':require('../../static/images/case/2-1.png')},
							{'url':require('../../static/images/case/2-2.png')},
							{'url':require('../../static/images/case/2-3.png')},
							{'url':require('../../static/images/case/2-4.png')},
						]
					},
					{
						id:3,
						title: '广东 - 深圳 - 智能存包柜案例详情',
						text: '基于微信扫码的智能存包柜，利用移动互联网+存包柜的方式，升级了传统存包柜，解决传统存包柜的痛点使用起来更加便利。正是这种切实解决用户痛点的前瞻性服务，智能存包柜凭借优良的性能得到了广泛的应用。目前，在机场、超市、商场、游乐场、学校、图书馆、车站等场所中，都能看到智能存包柜的身影。而智能存包柜的安全性更是在使用中受到了一致好评。智能存包柜将微信端+服务端+柜子终端+系统后台相结合，依托于智慧云平台，记录分析数据。强大的后台管理功能可统计用户操作数据，查看柜子及各柜门状态。以往商户需要雇佣专人看管存储柜，且无法实时査看存包柜状态，有了智能存包柜这些全部都自动管理，管理者可随时查看。智能存包柜采用特殊结构设计，电控锁安装在柜体内，不占用空间，具备防盗功能。在紧急情况下，可通过紧急开锁装置应急开锁，解决了机器坏死后无法开锁的问题，把服务保障落实到位，实时保障用户的利益。',
						imglist: [
							{'url':require('../../static/images/case/3-1.png')},
							{'url':require('../../static/images/case/3-2.png')},
							{'url':require('../../static/images/case/3-3.png')},
							{'url':require('../../static/images/case/3-4.png')},
						]
					},
					{
						id:4,
						title: '浙江 - 杭州 - 智能洗衣柜案例详情',
						text: '智能洗衣收发柜是基于物联网架构,通过软件+硬件的集成,实现洗衣下单支付、衣物收发、监控、统计和管理整个操作过程都在系统可视化管理中进行;责任明确,省时省力,大大的降低了人工管理成本。系统方案设计特点：1.24小时自助收发衣物,平台或商家收到系统订单后自动分配给负责该商圈的店员,订单状态实时跟踪,用户体验好,清洗物的存取过程不用显示密码,仅使用随机生成的二维码,保证安全性。2.平台化管理,将智能柜、微信公众号与门店后台管理系统完美无缝对接,实现省时高效的020经营模式。3.可实现多层验证机制,比如密码、刷卡、人脸验证成功后方可登陆智能柜,管理后台可对洗衣店及人员进行权限设置、订单查询、物品存取记录、用户操作记录的管理。',
						imglist: [
							{'url':require('../../static/images/case/4-1.png')},
							{'url':require('../../static/images/case/4-2.png')},
							{'url':require('../../static/images/case/4-3.png')},
							{'url':require('../../static/images/case/4-4.png')},
						]
					},
					{
						id:5,
						title: '上海 - 智能取餐柜案例详情',
						text: '智能取餐柜外观类似储物柜,主要功能是将外卖进行识别,暂存,监控,保温的设备,保证企业员工或高校学生能吃上热腾腾的饭菜,目前有不少国内的高校,已开始引用智能取餐柜设备。智能取餐柜为用户接收外卖提供相较便利的时间和地点,取餐流程简单快捷,用户下单后,商家安排外卖小哥将饭菜配送到取餐柜内,外卖小哥存餐后用户会收到短信验证码,用户只需要通过验证码取餐即可.智能取餐柜最大的价值在于其创新的模式,提高了整个外卖行业的效率。智能取餐柜可以放在学校食堂,公司饭堂等人流量大的公共场所,直接在用户端使用。每日在线研发的智能取餐柜已大批量投放市场,客户也遍布全国各地,从目前的成果来看,已大大解决了很多上班族没空吃早餐、中午吃饭难以及学校、医院食堂就餐拥挤的问题,运营效果十分可观。',
						imglist: [
							{'url':require('../../static/images/case/5-1.png')},
							{'url':require('../../static/images/case/5-2.png')},
							{'url':require('../../static/images/case/5-3.png')},
							{'url':require('../../static/images/case/5-4.png')},
						]
					},
					{
						id:6,
						title: '陕西 - 西安 - 智能快递柜案例详情',
						text: '随着快递柜的快速发展，我们的生活不断便捷，智能储物柜的应用使物品便于存储，现代社会，网购已是人们重要的购物途径，而购物习惯的变化，已使中国的快递行业在过去的十年中迅速成长起来。但是目前智能快递柜在我国还处于发展的初级阶段。很多地方还不完善，常常使用过程中会出现一些问题和用户的投诉，在短期内很难大规模的使用和推广，所以我们仍需慢慢摸索。总而言之，目前我国智能快递柜的发展前景十分乐观，市场潜力巨大，但同时也面临着诸多发展难题。智能快递柜目前主要有三种运行模式：快递行业自建自用、电商自建自用、第三方平台公用。很多高科技公司也相继推出了各种智能快递柜，分布在高校、写字楼、工厂、园区、公司网点、物业、社区等地。为人们提供快速便利的快递取件服务。 ',
						imglist: [
							{'url':require('../../static/images/case/6-1.png')},
							{'url':require('../../static/images/case/6-2.png')},
							{'url':require('../../static/images/case/6-3.png')},
							{'url':require('../../static/images/case/6-4.png')},
						]
					},
					{
						id:7,
						title: '浙江 - 杭州 - 智能售货机案例详情',
						text: '为回应政府部门呼吁，协助解决医疗器材防护装备供求矛盾，它有着“自助式选购”“身份核查”“人体体温检验”“消菌木马查杀”“后台管理监管”“有效分派”“大数据处理”“两个版本实际操作”等几个闪光点作用。智能支付 手机扫码支付出货，无接触式购物更安心 |远程管理 智慧运营平台，远程控制、高效运营 |小体积大容量。 ',
						imglist: [
							{'url':require('../../static/images/case/7-1.png')},
							{'url':require('../../static/images/case/7-2.png')},
							{'url':require('../../static/images/case/7-3.png')},
							{'url':require('../../static/images/case/7-4.png')},
						]
					},
					{
						id:8,
						title: '上海 - 智能售货机案例详情',
						text: '大容量美妆美瞳自动售卖机，24小时自动售卖，可放置200种美妆用品，客户自取，方便快捷！大牌美妆小样与自动售货机的结合，能够利用自动售货机自身存在的优势，为品牌方排忧解难，自动售货机则可以进入到精准场景，如商超、大学校园，或是母婴人群区域等，做精准派发，从而帮助品牌更精确地获得线下用户。同时，这也是一个全链路的解决方案，不只是把样派出去，还可以触发消费者后续购买等行为。通过打造各种跨界的品牌联动营销方式,在实现品牌裂变的同时也有助于企业私域流量的建设,从而促进品牌与用户之间的深度互动。除此之外，自动售货机因本身独特的自助售卖方式深受品牌方喜爱，自动售货终端能够更好的服务于目标消费者，实现广告价值最大化。 ',
						imglist: [
							{'url':require('../../static/images/case/8-1.png')},
							{'url':require('../../static/images/case/8-2.png')},
							{'url':require('../../static/images/case/8-3.png')},
							{'url':require('../../static/images/case/8-4.png')},
						]
					},
				],
				caselist2: [
					{
						id:1,
						title: 'Tibet - Lhasa - Smart Express Cabinet Case Details',
						text: "With the rapid development of express lockers, our lives are becoming more and more convenient. The application of smart lockers makes it easy to store items. In modern society, online shopping has become an important way of shopping for people, and changes in shopping habits have made China's express delivery industry in It has grown rapidly over the past decade. However, at present, smart express cabinets are still in the initial stage of development in my country. Many places are not perfect, and there are often some problems and user complaints during the use process. It is difficult to use and promote it on a large scale in the short term, so we still need to explore slowly. All in all, the development prospects of my country's smart express cabinets are very optimistic at present, and the market potential is huge, but at the same time, it is also facing many development problems. At present, there are three main operating modes of smart express cabinets: self-construction and self-use in the express industry, self-construction and self-use by e-commerce, and public use by third-party platforms. Many high-tech companies have also successively launched various smart express cabinets, which are distributed in universities, office buildings, factories, parks, company outlets, properties, communities and other places. Provide people with fast and convenient express pickup service.",
						imglist: [
							{'url':require('../../static/images/case/1-1.png')},
							{'url':require('../../static/images/case/1-2.png')},
							{'url':require('../../static/images/case/1-3.png')},
							{'url':require('../../static/images/case/1-4.png')},
						]
					},
					{
						id:2,
						title: 'Shandong - Qingdao - RFID smart cabinet case details',
						text: "The RFID smart phone cabinet is based on the RFID Internet of Things technology. RFID has a unique ID code in the world, which cannot be copied to ensure its uniqueness. Each tool to be managed is inlaid with RFID electronic tags for identification, and the inside of the cabinet is an RFID monitoring system. Real-time Detect the item information in the cabinet. The user information is determined by fingerprint and face recognition. The moment the user opens the door, the vision system will take the initiative to capture the information to prevent others from stealing the personal information. If the user takes any item, the system will automatically identify it and push the data to the background to generate a report. At the same time, the smart RFID mobile phone locker can set the access and unlock time period in the background. RFID smart cabinets help enterprises deploy and manage items flexibly, safely, and at low cost, and realize visual management.",
						imglist: [
							{'url':require('../../static/images/case/2-1.png')},
							{'url':require('../../static/images/case/2-2.png')},
							{'url':require('../../static/images/case/2-3.png')},
							{'url':require('../../static/images/case/2-4.png')},
						]
					},
					{
						id:3,
						title: 'Guangdong - Shenzhen - Smart Locker Case Details',
						text: "The smart locker based on WeChat scan code uses the mobile Internet + locker to upgrade the traditional locker, solving the pain points of the traditional locker and making it more convenient to use. It is this forward-looking service that effectively solves the user's pain points, and the smart locker has been widely used with its excellent performance. At present, smart lockers can be seen in airports, supermarkets, shopping malls, playgrounds, schools, libraries, stations and other places. The safety of the smart locker has been unanimously praised in use. The smart locker combines WeChat terminal + server terminal + cabinet terminal + system background, and relies on the smart cloud platform to record and analyze data. The powerful background management function can count user operation data and check the status of cabinets and cabinet doors. In the past, merchants needed to hire special personnel to take care of the storage cabinets, and they could not check the status of the storage cabinets in real time. With the smart storage cabinets, all these are automatically managed, and managers can check them at any time. The intelligent storage cabinet adopts a special structure design, the electric control lock is installed in the cabinet, does not occupy space, and has the anti-theft function. In an emergency, the emergency unlocking device can be used to unlock the door in an emergency, which solves the problem that the machine cannot be unlocked after necrosis, puts the service guarantee in place, and protects the interests of users in real time.",
						imglist: [
							{'url':require('../../static/images/case/3-1.png')},
							{'url':require('../../static/images/case/3-2.png')},
							{'url':require('../../static/images/case/3-3.png')},
							{'url':require('../../static/images/case/3-4.png')},
						]
					},
					{
						id:4,
						title: 'Zhejiang - Hangzhou - Case Details of Smart Laundry Cabinets',
						text: "The intelligent laundry receiving and dispatching cabinet is based on the Internet of Things architecture. Through the integration of software and hardware, the entire operation process of laundry order payment, clothing receiving and dispatching, monitoring, statistics and management is carried out in the visual management of the system; the responsibility is clear, time-saving and labor-saving, and greatly reduce labor management costs. Design features of the system solution: 1.24 hours self-service sending and receiving of clothes, the platform or the merchant automatically assigns the order to the clerk in charge of the business area after receiving the system order, the order status is tracked in real time, the user experience is good, the access process of the cleaning object does not need to display the password, only use Randomly generated QR code to ensure security. 2. Platform management, perfect and seamless connection of smart cabinets, WeChat public accounts and store back-end management systems, to achieve a time-saving and efficient 020 business model. 3. Multi-layer verification mechanism can be realized, such as password, card swiping, and face verification before you can log in to the smart cabinet. The management background can set permissions, order inquiries, item access records, and user operation records for laundromats and personnel.",
						imglist: [
							{'url':require('../../static/images/case/4-1.png')},
							{'url':require('../../static/images/case/4-2.png')},
							{'url':require('../../static/images/case/4-3.png')},
							{'url':require('../../static/images/case/4-4.png')},
						]
					},
					{
						id:5,
						title: 'Shanghai - Case Details of Smart Pick-up Cabinet',
						text: "The appearance of the intelligent dining cabinet is similar to the storage cabinet. The main function is to identify, temporarily store, monitor, and keep warm equipment, so as to ensure that enterprise employees or college students can eat hot meals. At present, many domestic colleges and universities have already Start citing smart food cabinet devices. The intelligent pick-up cabinet provides a relatively convenient time and place for users to receive takeaways. The process of picking up meals is simple and fast. After the user places an order, the merchant arranges the takeaway brother to deliver the food to the takeaway cabinet. After the takeaway brother stores the meal, the user will After receiving the SMS verification code, the user only needs to use the verification code to pick up the meal. The biggest value of the smart food pickup cabinet lies in its innovative model, which improves the efficiency of the entire takeaway industry. The intelligent dining cabinet can be placed in public places with high traffic such as school canteens, company canteens, etc., and used directly on the user side. The intelligent dining cabinets developed online every day have been put on the market in large quantities, and customers are all over the country. Judging from the current results, many office workers have no time to eat breakfast, it is difficult to eat at noon, and the canteens of schools and hospitals are crowded. problem, the operating effect is very impressive.",
						imglist: [
							{'url':require('../../static/images/case/5-1.png')},
							{'url':require('../../static/images/case/5-2.png')},
							{'url':require('../../static/images/case/5-3.png')},
							{'url':require('../../static/images/case/5-4.png')},
						]
					},
					{
						id:6,
						title: "Shaanxi - Xi'an - Smart Express Cabinet Case Details",
						text: "With the rapid development of express lockers, our lives are becoming more and more convenient. The application of smart lockers makes it easy to store items. In modern society, online shopping has become an important way of shopping for people, and changes in shopping habits have made China's express delivery industry in It has grown rapidly over the past decade. However, at present, smart express cabinets are still in the initial stage of development in my country. Many places are not perfect, and there are often some problems and user complaints during the use process. It is difficult to use and promote it on a large scale in the short term, so we still need to explore slowly. All in all, the development prospects of my country's smart express cabinets are very optimistic at present, and the market potential is huge, but at the same time, it is also facing many development problems. At present, there are three main operating modes of smart express cabinets: self-construction and self-use in the express industry, self-construction and self-use by e-commerce, and public use by third-party platforms. Many high-tech companies have also successively launched various smart express cabinets, which are distributed in universities, office buildings, factories, parks, company outlets, properties, communities and other places. Provide people with fast and convenient express pickup service.",
						imglist: [
							{'url':require('../../static/images/case/6-1.png')},
							{'url':require('../../static/images/case/6-2.png')},
							{'url':require('../../static/images/case/6-3.png')},
							{'url':require('../../static/images/case/6-4.png')},
						]
					},
					{
						id:7,
						title: 'Zhejiang - Hangzhou - Smart vending machine case details',
						text: 'In response to the appeal of government departments and to help solve the contradiction between supply and demand of medical equipment and protective equipment, it has several prominent functions such as "self-service purchase", "identity verification", "body temperature inspection", "anti-virus Trojan horse detection and killing", "background management and supervision", "effective distribution", "big data processing" and "two versions of actual operation". Smart pay phone code to pay shipping, the non-contact shopping more secure | remote management Intelligent operating platform, the remote control of large capacity, high-efficiency operation | small volume. ',
						imglist: [
							{'url':require('../../static/images/case/7-1.png')},
							{'url':require('../../static/images/case/7-2.png')},
							{'url':require('../../static/images/case/7-3.png')},
							{'url':require('../../static/images/case/7-4.png')},
						]
					},
					{
						id:8,
						title: 'Shanghai - Smart Vending Machine case details',
						text: 'Large capacity beauty pupil automatic vending machine, 24 hours automatic sale, can place 200 kinds of beauty products, customers can pick up, convenient and fast! The combination of brand-name beauty samples and vending machines can make use of the advantages of the vending machine itself to solve the problems for the brand side. The vending machine can enter the precise scene, such as supermarkets, university campuses, or areas of maternal and child groups, to do accurate distribution, so as to help the brand more accurately obtain offline users. At the same time, this is also a full-link solution, not only to send samples, but also to trigger subsequent consumer purchases and other behaviors. By creating a variety of cross-border brand linkage marketing methods, it can not only achieve brand fission, but also contribute to the construction of enterprise private traffic, so as to promote the deep interaction between the brand and the user. In addition, the vending machine is favored by the brand because of its unique way of self-service sales. The vending terminals can better serve the target consumers and maximize the advertising value. ',
						imglist: [
							{'url':require('../../static/images/case/8-1.png')},
							{'url':require('../../static/images/case/8-2.png')},
							{'url':require('../../static/images/case/8-3.png')},
							{'url':require('../../static/images/case/8-4.png')},
						]
					},
				]
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
			let _this = this;
			_this.$nextTick(() => { // 在dom渲染完后,再执行动画
				var wow = new WOW({
					boxClass: 'wow',///动画元件css类（默认为wow）
					animateClass: 'animated',//动画css类（默认为animated） 
					offset: 0,//到元素距离触发动画（当默认为0） 
					mobile: true, //在移动设备上触发动画（默认为true） 
					live: true//对异步加载的内容进行操作（默认为true）
				})
				wow.init()
			})
			
			
			let index = _this.$route.query.id;
			
			
			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			
			
			
			
			
			if(_this.currlangs == 2) {
				_this.langs = sp;
				_this.currCase = _this.caselist2[index];
				// console.info(_this.currCase);
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
				_this.currCase = _this.caselist2[index];
				// console.info(_this.currCase);
			} else {
				_this.langs = zh;
				_this.currCase = _this.caselist1[index];
				// console.info(_this.currCase);
			}
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.case-content{
		padding: 30px 0px 50px;
		background-color: #f5f5f5;
	}
	.case-title{
		margin: 25px 0px 30px;
		padding: 22px 15px;
		background-color: #fff;
		border-left: 3px solid #409EFF;
	}
	.case-detail{
		border: 1px solid #ccc;
		padding: 50px 200px;
		background-color: #fff;
	}
	.case-detail h2{
		font-weight: 100;
		width: 100%;
		text-align: center;
		padding-bottom: 30px;
		border-bottom: 1px solid #ccc;
	}
	.case-detail-image{
		padding: 2px;
	}
	.case-detail-text{
		margin: 20px 0px;
		font-size: 16px;
		line-height: 28px;
		color: #666;
	}
	@media screen and (max-width:768px) {
		.case-content{
			padding: 10px 0px 50px;
		}
		.case-title{
			margin: 15px 0px;
		}
		.case-detail{
			padding: 30px 10px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/casedetail.vue